import { useState } from 'react';
import { FaBook } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useUserAPI } from '../../api/user/useUserAPI';
import { useSession } from '../../stores/session/SessionAction';
import { useSessionAPI } from '../../api/session/useSessionAPI';

import logo from '../../images/Logo.png';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const userAPI = useUserAPI();
  const dispatch = useDispatch();
  const sessionAPI = useSession();
  const sessionRawAPI = useSessionAPI();

  const handleSubmit = async (e) => {
    e.preventDefault();
    userAPI.login({ username, password })
      .then(async (response) => {
        try {
          const sessionData = await sessionRawAPI.get();
          const dashboardPath = sessionData?.dashboardPath || '/dashboard';
          window.location.href = dashboardPath;
        } catch {
          window.location.href = '/dashboard';
        }
      })
      .catch((error) => {
        console.error('Login failed:', error);
        alert('Login failed. Please check your username and password.');
        setPassword('');
      });
  };

  return (
    <div className="login-container">
      {/* 오른쪽 위 구석: 로그인 없이 보는 공개 매뉴얼 (새 탭) */}
      <a
        className="login-manual"
        href="/manual/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="login-manual-link"
      >
        <FaBook />
        <span>사용자 매뉴얼</span>
      </a>
      <div className="login">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <LoginForm 
          username={username} 
          setUsername={setUsername}
          password={password}
          setPassword={setPassword}
          handleSubmit={handleSubmit}
        />
        {/* <LoginFooter /> */}
      </div>
    </div>
  );
}

function LoginForm({ username, setUsername, password, setPassword, handleSubmit }) {
    return (
      <div className="login-form">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="아이디"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="glowing-btn">Login</button>
        </form>
      </div>
    );
  }
  
function LoginFooter() {
  return (
    <div className="login-footer">
      <label htmlFor="check">
        <input type="checkbox" id="check" /> 로그인 상태 유지
      </label>
    </div>
  );
}

export default Login;
